// @flow
import {
  HUD_TOGGLE,
  HUD_SET_STEP,
  HUD_SET_TOUR_IN_PROGRESS,
} from 'actions/hud';

const INITIAL_STATE = {
  hudTourSeen: localStorage.hud_tour_seen || false,
  hudTourInProgress: false,
  open: false,
  step: 0,
};

export default function reduce(
  state = INITIAL_STATE,
  { type, open, step, hudTourInProgress }
) {
  switch (type) {
    case HUD_TOGGLE:
      return {
        ...state,
        open,
      };

    case HUD_SET_STEP:
      return {
        ...state,
        step,
      };

    case HUD_SET_TOUR_IN_PROGRESS:
      return {
        ...state,
        hudTourInProgress,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/hud.js